import { combineReducers } from '@reduxjs/toolkit';
import { customerRegistrationReducer } from './reducers/customer-registration-reducer';
import { billingAddressRegistrationReducer } from './reducers/billing-address-reducer';
import { adminUserRegistrationReducer } from './reducers/admin-user-registration-reducer';
import { stepsReducer } from './reducers/steps-reducer';
import { customerCreationReducer } from './reducers/customer-creation-reducer';
import { organizationsWithCustomersReducer } from './reducers/organizations-customers-list-reducer';
import { customerAccountManagerReducer } from './reducers/customer-account-manager-reducer';
import { customerUsersReducer } from './reducers/customer-users-reducer';
import { customersLicensesReducer } from './reducers/customer-licenses-reducer';
import { customerUsersWithRolesReducer } from './reducers/customer-users-roles-reducer';
import { accountRepresentativesListReducer } from './reducers/account-representatives-list-reducer';
import { customerAccountRepresentativeReducer } from './reducers/customer-account-representative-reducer';
import { customersListReducer } from './reducers/customers-list-reducer';
import { customerSelectedReducer } from './reducers/customer-select-reducer';
import { customerApplicationsReducer } from './reducers/customer-applications-reducer';
import { customerUsersExternalSelectionReducer } from './reducers/customer-users-external-selection';
import { customerActiveReducer } from './reducers/customer-active-reducer';
import selectedCustomerSlice from './reducers/selected-customer.slice';
import type { ICompanyState } from './interfaces';

export default combineReducers<ICompanyState>({
  customerRegistrationReducer,
  billingAddressRegistrationReducer,
  adminUserRegistrationReducer,
  customerCreationReducer,
  organizationsWithCustomersReducer,
  customersLicensesReducer,
  customersListReducer,
  stepsReducer,
  customerUsersReducer,
  customerUsersWithRolesReducer,
  customerAccountManagerReducer,
  accountRepresentativesListReducer,
  customerAccountRepresentativeReducer,
  customerSelectedReducer,
  customerApplicationsReducer,
  customerUsersExternalSelectionReducer,
  customerActiveReducer,
  selectedCustomerSlice,
});
